export var PAGE_NAME = {
    None: 'none',
    Calendar: 'cal',
    EntryForm: 'form',
    EntryForm2: 'form2',
    Product: 'product',
    Payment: 'payment',
};
export var DATETIME_FORMAT = {
    // 2022-02-06T00:00:00+09:00
    FOR_API: "yyyy-MM-dd'T'HH:mm:ssxxx",
    DATE_TIME: 'yyyy-MM-dd HH:mm',
    HHMM: 'H:m',
    MMDD: 'M/d',
    DAY_OF_WEEK: 'eee',
    YYYYMMDD_JP: 'yyyy年 M月 d日',
    YYYYMMDD_HHMM_JP: 'yyyy年 M月 d日 HH時 mm分',
};
export var SCHEDULE_STATUS_CNST = {
    None: 0,
    Possible: 1,
    Full: 2,
    Paid: 3,
    Expired: 4,
};
export var SCHEDULE_STATUS_KBN = {
    0: '',
    1: '空',
    2: '満',
    3: '満',
    4: '✕',
};
// 予約は利用日の何日前まで可能か（日付単位。2 = 前日・当日は不可）
export var ENTRY_DEADLINE_DAYS = 2;
export var RESULT_CODE_CONST = {
    ENTRY_DEADLINE_OVER: 'ENTRY_DEADLINE_OVER',
};
export var ENTRY_DEADLINE_OVER_MESSAGE = 'ご希望の日は予約受付期限を過ぎています（ご予約は利用日の2日前まで）。別の日をお選びください。';
export var PAYMENT_METHOD_CONST = {
    CARD: 1,
    COUPON: 2,
    SUBSCRIPTION: 3,
};
// 支払い状況
export var PAYMENT_STATUS_CONST = {
    UNPAID: 2,
    PAID: 3,
    REFUNDED: 9,
};
export var PAYMENT_STATUS_KBN_UNPAID = { name: '支払待', value: PAYMENT_STATUS_CONST.UNPAID };
export var PAYMENT_STATUS_KBN_PAID = { name: '支払済', value: PAYMENT_STATUS_CONST.PAID };
export var PAYMENT_STATUS_KBN_REFUNDED = { name: '返金済', value: PAYMENT_STATUS_CONST.REFUNDED };
export var PAYMENT_STATUS_KBN = [
    PAYMENT_STATUS_KBN_UNPAID,
    PAYMENT_STATUS_KBN_PAID,
    PAYMENT_STATUS_KBN_REFUNDED,
];
